import React, { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { InfoBanner } from "@screencloud/screencloud-ui-components";
import { EditorError } from "../../types";
import { removeError } from "../../actions";

import "./ErrorMessage.scss";

interface ErrorMessageProps {
  error: EditorError;
}

const ErrorMessage = (
  props: ErrorMessageProps
): ReactElement<ErrorMessageProps> => {
  const dispatch = useDispatch();

  const [errorVisible, setErrorVisible] = useState(true);

  const { error } = props;

  useEffect(() => {
    dispatch(removeError(error));
    const timer = setTimeout(() => {
      // display error message only for 5 seconds
      setErrorVisible(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [dispatch, error]);

  return errorVisible ? (
    <InfoBanner
      className="errorInfo"
      title={error.error}
      description={""}
      color="error"
      mini
      icon={"warning"}
    />
  ) : (
    <div />
  );
};

export default ErrorMessage;
